import { Pipe, PipeTransform } from '@angular/core';
import { TimezoneService } from '../../core/services/timezone.service';

@Pipe({
  name: 'utcToLocal',
  standalone: false,
})
export class UtcToLocalPipe implements PipeTransform {
  constructor(private readonly timezoneService: TimezoneService) {}

  transform(value: string | null | undefined, timezone?: string | null): string {
    const normalized = `${value || ''}`.trim();
    if (!normalized) {
      return '';
    }

    const converted = this.timezoneService.utcIsoToLocalInput(normalized, timezone);
    return converted || normalized;
  }
}
